import { useEffect, useMemo } from 'react';

import { useCaseReportStatistics } from '@utils/hooks/useCaseReportStatistics';
import { useDisclosuresStatistics } from '@utils/hooks/useDisclosuresStatistics';
import { useSurveysStatistics } from '@utils/hooks/useSurveysStatistics';

import { servicesStatistics } from '@boot/reactiveVariables';

export interface ServicesStatistics {
    casesLoading: boolean;
    disclosuresCount: number;
    disclosuresLoading: boolean;
    ongoingCases: number;
    respondedDisclosures: number;
    surveysCount: number;
    surveysLoading: boolean;
}

export const useServicesStatistics = () => {
    const { data: casesData, loading: casesLoading } = useCaseReportStatistics({
        fetchPolicy: 'cache-and-network',
    });
    const { data: disclosuresData, loading: disclosuresLoading } =
        useDisclosuresStatistics({ fetchPolicy: 'cache-only' });
    const { data: surveysData, loading: surveysLoading } = useSurveysStatistics(
        { fetchPolicy: 'cache-only' },
    );

    // TODO: remove deprecated code and add unreadCount from backend after chat refactor (blocked by SPD-2779)

    const statistics: ServicesStatistics = useMemo(
        () => ({
            casesLoading,
            disclosuresCount:
                disclosuresData?.statistics.availableDisclosures ?? 0,
            disclosuresLoading,
            ongoingCases: casesData?.caseReports.statistics.ongoing ?? 0,
            respondedDisclosures:
                disclosuresData?.statistics.responsesCount ?? 0,
            surveysCount: surveysData?.statistics.totalCount ?? 0,
            surveysLoading,
        }),
        [
            casesLoading,
            disclosuresData,
            disclosuresLoading,
            casesData,
            surveysData,
            surveysLoading,
        ],
    );

    useEffect(() => {
        servicesStatistics(statistics);
    }, [statistics]);
};
